let reducedMotionQuery: MediaQueryList | undefined

function getReducedMotionQuery(): MediaQueryList | undefined {
	if (typeof window.matchMedia !== 'function') return undefined
	reducedMotionQuery ??= window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	)
	return reducedMotionQuery
}

export function prefersReducedMotion(): boolean {
	return getReducedMotionQuery()?.matches ?? false
}

export function motionEnabled(): boolean {
	return !prefersReducedMotion()
}

export function ambientMotionEnabled(): boolean {
	return (
		window.Ucoast?.enableAmbientMotion !== false && motionEnabled()
	)
}

export function revealMotionEnabled(): boolean {
	return window.Ucoast?.enableRevealMotion !== false && motionEnabled()
}
